import { useState, useCallback } from 'react';

import { useHttpClient } from './http-hook';

export const useSection = () => {
  const [sections, setSections] = useState([]);
  const { sendRequest } = useHttpClient();

  const fetchAllSections = useCallback(async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/section/client`
      );

      setSections(responseData.data.data);
    } catch (err) {}
  }, [sendRequest]);

  return { sections, fetchAllSections };
};
